import {
  StyleParamType,
  wixColorParam,
  wixFontParam,
  createStylesParams,
} from '@wix/tpa-settings';
import {
  StyleType,
  wixColor,
} from '@wix/editor-platform-ooi-metadata-resolver';

export type IStylesParams = {
  backgroundColor: StyleParamType.Color;
  primaryFont: StyleParamType.Font;
  titleFont: StyleParamType.Font;
  textColor: StyleParamType.Color;
  buttonTextColor: StyleParamType.Color;
  buttonOpacityAndColor: StyleParamType.Color;
  borderColor: StyleParamType.Color;
  borderWith: StyleParamType.Number; // the typo is intended :(
};

export default createStylesParams<IStylesParams>({
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor('wst-primary-background-color'),
    },
  },
  primaryFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 20,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: { type: 'static', preset: 'Body-M', size: 20 },
    },
  },
  titleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-M', {
      size: 20,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: { type: 'static', preset: 'Heading-M', size: 20 },
    },
  },
  textColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: { type: 'static', preset: 'color-5', opacity: 1 },
    },
  },
  buttonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: { type: 'static', preset: 'color-1', opacity: 1 },
    },
  },
  buttonOpacityAndColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: {
      type: StyleType.color,
      defaultValue: { type: 'static', preset: 'color-8', opacity: 1 },
    },
  },
  borderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: { type: 'static', preset: 'color-2', opacity: 1 },
    },
  },
  borderWith: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: { type: 'static', value: 0 },
    },
  },
});
